<template>
  <section class="section" id="oll-section">
    <!-- Filter Buttons -->
    <OLLFilterButtons
      :active-filter="activeFilter"
      @filter-change="(filterName) => (activeFilter = filterName)"
      @edit-set="startEditingSet"
    />

    <!-- <OLLFilterButtons
      :active-filter="activeFilter"
      @filter-change="setFilter"
    /> -->

    <div class="grid-container">
      <!-- Filter Buttons -->

      <!-- Info Card -->
      <div class="grid-item info-card">
        <div class="exampleText">
          <h2 class="fsize24 mainColor"><b>OLL</b></h2>
          <p>Orientation of Last Layer</p>
          <p>
            <b>[SX] = R U R'<span class="mainColor2"> U'</span></b>
          </p>

          <p>
            <b>[SX left] = L' U' L U</b>
          </p>

          <p>
            <b>[sh] = R' F R F'</b>
          </p>

          <p>
            <b>[sh left] = L F' L' F</b>
          </p>
          <a href="#home-section">Go to the top</a><br />
          <a href="#f2l-section">Go to F2L</a><br />
          <a href="#pll-section">Go to PLL</a>
        </div>
      </div>

      <!-- OLL Cards -->
      <OLLCard
        v-for="algo in visibleAlgorithms"
        :key="algo.id"
        :number="algo.number"
        :image="algo.image"
        :algorithm="algo.algorithm"
        :scramble="algo.scramble"
        :scramble-class="algo.scrambleClass"
        :note="algo.note"
        :css="algo.cssOll"
      />
    </div>

    <!-- Set Editor Modal -->
    <OLLSetEditor
      :is-open="editingSet !== null"
      :set-name="editingSet"
      :all-algorithms="ollAlgorithms"
      :temp-selection="tempSelection"
      @close="cancelEditing"
      @toggle="toggleAlgorithm"
      @save="saveCustomSet"
      @reset="handleReset"
    />

    <!-- Debug info - remove after testing -->
    <!-- <div
      style="
        position: fixed;
        bottom: 10px;
        right: 10px;
        background: yellow;
        padding: 10px;
      "
    >
      editingSet: {{ editingSet }}<br />
      tempSelection: {{ tempSelection.length }} items
    </div> -->
  </section>
</template>

<script setup>
import { ref, computed } from 'vue';

import { ollAlgorithms, ollCategories } from './data/ollData';
//import { useAlgorithmFilter } from './composables/useAlgorithmFilter';
import { useOLLCustomSet } from './composables/useOLLCustomSet';
import OLLCard from './OLLCard.vue';
import OLLFilterButtons from './OLLFilterButtons.vue';
import OLLSetEditor from './OLLSetEditor.vue';

// Use custom set management
const {
  editingSet,
  tempSelection,
  getCurrentSet,
  startEditingSet,
  toggleAlgorithm,
  saveCustomSet,
  cancelEditing,
  resetToDefault,
} = useOLLCustomSet();

// Active filter
const activeFilter = ref('all');

// Get visible algorithms based on active filter
const visibleAlgorithms = computed(() => {
  if (activeFilter.value === 'all') {
    return ollAlgorithms;
  }

  // Check if it's a custom "to learn" set
  if (activeFilter.value === 'tolearn' || activeFilter.value === 'tolearn2') {
    const customIds = getCurrentSet(activeFilter.value);
    return ollAlgorithms.filter((algo) => customIds.includes(algo.id));
  }

  // Regular category filter
  const filter = ollCategories[activeFilter.value];
  if (!filter) return ollAlgorithms;

  if (filter.items === 'all') return ollAlgorithms;

  return ollAlgorithms.filter((algo) => filter.items.includes(algo.id));
});

// const { activeFilter, visibleAlgorithms, setFilter } = useAlgorithmFilter(
//   ollAlgorithms,
//   ollCategories
// );

// Handle reset button
const handleReset = () => {
  console.log('handleReset called, editingSet:', editingSet.value);
  if (editingSet.value) {
    resetToDefault(editingSet.value);
  }
};
</script>

<style scoped>
.section {
  margin: 0 auto 20px;
  padding: 16px 0px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  letter-spacing: 3px;
}

.grid-item h2 {
  color: #f08200;
  margin: 0 0 10px 0;
}

.exampleText {
  color: black;
}

.mainColor2 {
  color: #0075ce;
}

@media (max-width: 800px) {
  .grid-container {
    grid-template-columns: 1fr;
  }
}
</style>
